module.exports = __webpack_public_path__ + "static/media/ID.18281f77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ID.svg
// module id = 274
// module chunks = 0